import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { attorneyHubKnowledgeBaseRoot } from "knowledge-base/knowledge-base-locations";
import { Link as RouterLink, useNavigate } from "react-router";
import { useTutorials } from "_shared/tutorials/tutorial-provider";
import { useSession } from "users/__session/session-context";

export default function HelpPage() {
  const navigate = useNavigate();
  const session = useSession();
  const {
    disableTutorials,
    enableTutorials,
    resetTutorials,
    restartTutorials,
    startTutorial,
    tutorialsEnabled,
  } = useTutorials();
  const openOnboardingGuide = () => {
    startTutorial("onboarding-proposal");
    const proposalId = session.onboardingWork?.currentProposalId;
    navigate(proposalId ? `/proposals/active/revise/${proposalId}/details` : "/proposals");
  };
  const restartOnboardingGuide = () => {
    restartTutorials();
    const proposalId = session.onboardingWork?.currentProposalId;
    navigate(proposalId ? `/proposals/active/revise/${proposalId}/details` : "/proposals");
  };

  return (
    <Box sx={{ height: "100%", overflow: "auto", p: { xs: 2, sm: 4 } }}>
      <Paper elevation={1} sx={{ maxWidth: 760, mx: "auto", p: { xs: 3, sm: 5 } }}>
        <Stack spacing={2}>
          <Typography component="h1" variant="h4">Help</Typography>
          <Typography color="text.secondary">
            Search the knowledge base, walk through a guided tour, or contact AttorneyHub support.
          </Typography>
          <Button
            component={RouterLink}
            startIcon={<MenuBookIcon />}
            to={attorneyHubKnowledgeBaseRoot}
            variant="contained"
          >
            Browse help and FAQ
          </Button>
          <Typography color="text.secondary" variant="body2">
            You can also ask the AI assistant a question in your own words. It answers from these
            same pages, alongside the policies, fee schedules and agreements that apply to you.
          </Typography>
          <Stack direction={{ sm: "row", xs: "column" }} spacing={1}>
            <Button onClick={openOnboardingGuide} variant="outlined">
              Guide me
            </Button>
            <Button onClick={restartOnboardingGuide} variant="outlined">Restart guide</Button>
            {tutorialsEnabled ? (
              <Button onClick={disableTutorials} variant="outlined">Disable tutorials</Button>
            ) : (
              <Button onClick={enableTutorials} variant="outlined">Enable tutorials</Button>
            )}
            <Button onClick={() => void resetTutorials()} variant="text">Reset tutorial progress</Button>
          </Stack>
          <Button component="a" href="mailto:support@attorneyhub.com" startIcon={<ContactSupportIcon />} variant="outlined">
            Contact support
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
